import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { get, post } from '../../helpers/apiHelper';
import Swal from 'sweetalert2';

function CampaignPublicPage() {
    const { campaignId } = useParams();
    const [campaign, setCampaign] = useState(null);
    const [formData, setFormData] = useState({ email: '', code: '' });
    const [result, setResult] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        fetchCampaign();
    }, [campaignId]);

    const fetchCampaign = async () => {
        try {
            const data = await get(`game-loyalty/${campaignId}`);
            setCampaign(data);
        } catch (error) {
            console.error('Error al obtener la campaña:', error);
            Swal.fire('Error', error.message, 'error');
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleRedeem = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            // Llamada para canjear el código
            const response = await post(`game-loyalty/${campaignId}/redeem`, formData);
            setResult(response);

            if (response.prizeWon) {
                // Si ganó premio, enviamos un email felicitándolo.
                // Se asume que el endpoint /api/mail/send-reward está disponible y
                // que la campaña incluye la propiedad "marcaNombre" con el nombre del comercio.
                const emailPayload = {
                    email: formData.email,
                    clienteNombre: formData.email, // Si no tienes el nombre del cliente, usas el email como fallback.
                    marcaNombre: campaign.marcaNombre || campaign.nombre || 'Tu comercio',
                    reward: response.prizeWon,
                };

                await post('mail/send-reward', emailPayload);
                Swal.fire(
                    '¡Felicidades!',
                    'Has ganado un premio. Se ha enviado un correo con los detalles para recogerlo en el local.',
                    'success'
                );
            } else {
                Swal.fire(
                    'Participación registrada',
                    'Gracias por participar. ¡Suerte la próxima vez!',
                    'info'
                );
            }
        } catch (error) {
            console.error('Error al canjear el código:', error);
            Swal.fire('Error', error.message, 'error');
        } finally {
            setLoading(false);
        }
    };


    return (
        <div className="container mx-auto p-6">
            {campaign ? (
                <div>
                    <h1 className="text-3xl font-bold mb-2">{campaign.nombre}</h1>
                    {campaign.descripcion && <p className="mb-6">{campaign.descripcion}</p>}

                    <form onSubmit={handleRedeem} className="bg-white shadow-md rounded p-6">
                        <h2 className="text-2xl font-semibold mb-4">Validar tu Código</h2>
                        <div className="mb-4">
                            <label className="block mb-1 font-medium">Correo Electrónico</label>
                            <input
                                type="email"
                                name="email"
                                value={formData.email}
                                onChange={handleInputChange}
                                className="w-full border rounded px-3 py-2"
                                required
                            />
                        </div>
                        <div className="mb-4">
                            <label className="block mb-1 font-medium">Código</label>
                            <input
                                type="text"
                                name="code"
                                value={formData.code}
                                onChange={handleInputChange}
                                className="w-full border rounded px-3 py-2"
                                required
                            />
                        </div>
                        <button
                            type="submit"
                            disabled={loading}
                            className="bg-blue-600 text-white px-4 py-2 rounded"
                        >
                            {loading ? 'Procesando...' : 'Validar Código'}
                        </button>
                    </form>

                    {result && (
                        <div className="mt-6 p-4 bg-green-100 border border-green-400 rounded">
                            <h3 className="text-xl font-bold">Resultado del Canje</h3>
                            {result.prizeWon ? (
                                <p>
                                    ¡Enhorabuena! Has ganado: <strong>{result.prizeWon.nombre}</strong> – {result.prizeWon.descripcion}
                                </p>
                            ) : (
                                <p>Gracias por participar. Por desgracia, en esta ocasión no has ganado ningún premio.</p>
                            )}
                            <p>
                                Tu código: <strong>{result.participation.code}</strong>
                            </p>
                        </div>
                    )}
                </div>
            ) : (
                <p>Cargando detalles de la campaña...</p>
            )}
        </div>
    );
}

export default CampaignPublicPage;
